class VHGalleryThumbnails extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.rail = this.querySelector('[data-vh-thumbs]');
    this.previous = this.querySelector('[data-thumbnail-prev]');
    this.next = this.querySelector('[data-thumbnail-next]');
    if (!this.rail || !this.previous || !this.next) return;
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.rail.setAttribute('tabindex', '0');
    this.previous.addEventListener('click', () => this.move(-1), { signal });
    this.next.addEventListener('click', () => this.move(1), { signal });
    this.rail.addEventListener('scroll', () => this.update(), { signal, passive: true });
    this.rail.addEventListener('keydown', (event) => {
      if (!matchMedia('(min-width: 750px)').matches || this.dataset.overflow !== 'true') return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      event.stopPropagation();
      this.move(event.key === 'ArrowRight' ? 1 : -1);
    }, { signal });
    this.rail.addEventListener('wheel', (event) => {
      if (!matchMedia('(min-width: 750px)').matches || this.dataset.overflow !== 'true') return;
      if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
      const delta = event.deltaY * (event.deltaMode === 1 ? 16 : 1);
      const remaining = this.rail.scrollWidth - this.rail.clientWidth - this.rail.scrollLeft;
      if ((delta > 0 && remaining <= 1) || (delta < 0 && this.rail.scrollLeft <= 1)) return;
      event.preventDefault();
      this.rail.scrollBy({ left: delta, behavior: 'instant' });
    }, { signal, passive: false });
    this.resizeObserver = new ResizeObserver(() => this.update());
    this.resizeObserver.observe(this.rail);
    this.mutationObserver = new MutationObserver(() => this.update());
    this.mutationObserver.observe(this.rail, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    this.update();
  }
  move(direction) {
    this.rail.scrollBy({ left: direction * this.rail.clientWidth * 0.8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }
  update() {
    const overflow = matchMedia('(min-width: 750px)').matches && this.rail.scrollWidth > this.rail.clientWidth + 1;
    this.dataset.overflow = String(overflow);
    this.previous.hidden = !overflow;
    this.next.hidden = !overflow;
    this.previous.disabled = this.rail.scrollLeft <= 1;
    this.next.disabled = this.rail.scrollLeft >= this.rail.scrollWidth - this.rail.clientWidth - 1;
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
    this.controller = null;
  }
}
if (!customElements.get('vh-gallery-thumbnails')) customElements.define('vh-gallery-thumbnails', VHGalleryThumbnails);
